var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "md-headline" }, [_vm._v("Properties")]),
      _vm.showMarketplaceSwitch
        ? _c(
            "md-layout",
            [
              _c(
                "md-switch",
                {
                  staticClass: "md-primary",
                  attrs: {
                    disabled: !(
                      _vm.entity.status === "public" ||
                      _vm.$get(this, "entity.publicationDate.date")
                    )
                  },
                  model: {
                    value: _vm.entity.includeInMarketplace,
                    callback: function($$v) {
                      _vm.$set(_vm.entity, "includeInMarketplace", $$v)
                    },
                    expression: "entity.includeInMarketplace"
                  }
                },
                [_vm._v("Include this content in the Rhebus TV Marketplace")]
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "md-layout",
        [
          _c("genre-selector", {
            staticClass: "fixSize",
            attrs: {
              id: "categories-dropdown",
              multiple: true,
              "show-required-error":
                _vm.formSubmitted && _vm.validations.categories.$invalid
            },
            model: {
              value: _vm.entity.categories,
              callback: function($$v) {
                _vm.$set(_vm.entity, "categories", $$v)
              },
              expression: "entity.categories"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ffe53a1", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ffe53a1","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/forms/PropertiesForm.vue
// module id = 889
// module chunks = 0